import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BooleanValueAccessor, TextValueAccessor } from '@shui/angular';
import { BusinessServices, Roles } from '@shs-digi-care-monorepo/interfaces';
import { ShAssigneePickerComponent } from '../../sh-assignee-picker/sh-assignee-picker.component';
import { ShEditorComponent } from '../../sh-editor/sh-editor.component';
import { ShFileInputComponent } from '../../sh-file-input/sh-file-input.component';

export type { ReferralFormGroup } from '../model/parallel-referral-dialog.model';
import type { ReferralFormGroup } from '../model/parallel-referral-dialog.model';

@Component({
    selector: 'sh-referral-tab',
    templateUrl: './referral-tab.component.html',
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        ShEditorComponent,
        ShFileInputComponent,
        ShAssigneePickerComponent,
        BooleanValueAccessor,
        TextValueAccessor
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReferralTabComponent {
    public form: InputSignal<FormGroup<ReferralFormGroup>> = input.required();
    public canMarkCommentAsInternal: InputSignal<boolean> = input(false);
    public isReferredOutAfterSubmission: InputSignal<boolean> = input(false);
    public excludeIds: InputSignal<Set<string>> = input<Set<string>>(new Set());
    public businessService: InputSignal<BusinessServices | undefined> = input<BusinessServices | undefined>(undefined);
    public roles: InputSignal<Roles[]> = input<Roles[]>([Roles.TASK_OWNER]);
}
